// src/config/whatsapp.js
// Poné aquí tu número en formato internacional sin "+" ni espacios.
export const WHATSAPP_PHONE = "5493815677391";

// (Opcional) texto base por si querés un preset global
export const WA_PRESET_DEFAULT = null; 
